// Adapted from shadcn sidebar-08: navigation and collapsible submenus.
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowRight01Icon } from '@hugeicons/core-free-icons'
import { searchNavigation } from '@/lib/navigation'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible'
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar'

export function NavMain({
  groups,
  onNavigate,
}: {
  groups: ReturnType<typeof searchNavigation>
  onNavigate: () => void
}) {
  const { pathname } = useLocation()
  const [expanded, setExpanded] = useState<Record<string, boolean>>({})
  const isActive = (href: string) =>
    pathname === href || pathname.startsWith(`${href}/`)

  return groups.map((group) => {
    if (group.collapsible) {
      const first = group.items[0]
      return (
        <SidebarGroup key={group.label}>
          <SidebarMenu>
            <Collapsible
              asChild
              key={`${group.label}-${pathname}`}
              defaultOpen={
                group.items.some((item) => isActive(item.href)) ||
                expanded[group.label]
              }
              onOpenChange={(open) =>
                setExpanded((previous) => ({
                  ...previous,
                  [group.label]: open,
                }))
              }
            >
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip={group.label}>
                  <Link to={first.href} onClick={onNavigate}>
                    <HugeiconsIcon icon={first.icon} aria-hidden="true" />
                    <span>{group.label}</span>
                  </Link>
                </SidebarMenuButton>
                <CollapsibleTrigger asChild>
                  <SidebarMenuAction className="data-[state=open]:rotate-90">
                    <HugeiconsIcon icon={ArrowRight01Icon} aria-hidden="true" />
                    <span className="sr-only">Desplegar {group.label}</span>
                  </SidebarMenuAction>
                </CollapsibleTrigger>
                <CollapsibleContent>
                  <SidebarMenuSub>
                    {group.items.map((item) => (
                      <SidebarMenuSubItem key={item.href}>
                        <SidebarMenuSubButton
                          asChild
                          isActive={isActive(item.href)}
                        >
                          <Link
                            to={item.href}
                            onClick={onNavigate}
                            aria-current={
                              isActive(item.href) ? 'page' : undefined
                            }
                          >
                            <span>{item.title}</span>
                          </Link>
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    ))}
                  </SidebarMenuSub>
                </CollapsibleContent>
              </SidebarMenuItem>
            </Collapsible>
          </SidebarMenu>
        </SidebarGroup>
      )
    }
    return (
      <SidebarGroup key={group.label}>
        <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
        <SidebarMenu>
          {group.items.map((item) => (
            <SidebarMenuItem key={item.href}>
              <SidebarMenuButton
                asChild
                tooltip={item.title}
                isActive={isActive(item.href)}
              >
                <Link
                  to={item.href}
                  onClick={onNavigate}
                  aria-current={isActive(item.href) ? 'page' : undefined}
                >
                  <HugeiconsIcon icon={item.icon} aria-hidden="true" />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroup>
    )
  })
}
